import { useState, useEffect } from "react";
import { supabase } from "../../services/supabase";

export default function AdminStatistics() {
    const [messageCount, setMessageCount] = useState(0);
    const [newMessageCount, setNewMessageCount] = useState(0);
    const [dailyMessageCount, setDailyMessageCount] = useState(0);
    const [newsCount, setNewsCount] = useState(0);

    useEffect(() => {
        const fetchStats = async () => {
            const { count: totalMessages } = await supabase
                .from("messages")
                .select("id", { count: "exact", head: true });

            const { count: recentMessages } = await supabase
                .from("messages")
                .select("id", { count: "exact", head: true })
                .gte("created_at", new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString());

            const { count: last24hMessages } = await supabase
                .from("messages")
                .select("id", { count: "exact", head: true })
                .gte("created_at", new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString());

            const { count: totalNews } = await supabase
                .from("blogs")
                .select("id", { count: "exact", head: true });

            setMessageCount(totalMessages || 0);
            setNewMessageCount(recentMessages || 0);
            setDailyMessageCount(last24hMessages || 0);
            setNewsCount(totalNews || 0);
        };

        fetchStats();
    }, []);

    const percentChange = (current, total) => {
        if (total === 0) return "+100%";
        const diff = current - total;
        const percent = (diff / total) * 100;
        const sign = percent >= 0 ? "+" : "";
        return `${sign}${percent.toFixed(1)}%`;
    };

    const stats = [
        {
            title: "Total Messages",
            value: messageCount,
            change: "+0%",
            border: "gray",
        },
        {
            title: "New This Week",
            value: newMessageCount,
            change: percentChange(newMessageCount, messageCount),
            border: newMessageCount >= messageCount ? "green" : "red",
        },
        {
            title: "New in 24 Hours",
            value: dailyMessageCount,
            change: percentChange(dailyMessageCount, messageCount),
            border: dailyMessageCount >= messageCount ? "green" : "red",
        },
        {
            title: "News Publications",
            value: newsCount,
            change: "+0%",
            border: "gray",
        },
    ];

    return (
        <section className="py-10">
            <div className="max-w-7xl mx-auto px-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {stats.map((stat, idx) => (
                        <div
                            key={idx}
                            className="bg-white shadow-lg rounded-lg p-8 text-center"
                        >
                            <p className="text-lg text-neutral-500 font-medium mb-3">{stat.title}</p>
                            <h3 className="text-4xl font-bold text-gray-900 mb-4">{stat.value}</h3>

                            <div
                                className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border 
                                ${stat.border === "green"
                                    ? "bg-green-100 text-green-700 border-green-400"
                                    : stat.border === "red"
                                        ? "bg-red-100 text-red-700 border-red-400"
                                        : "bg-gray-100 text-gray-700 border-gray-300"
                                }`}
                            >
                                {stat.change}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
